import React from 'react';
import { GroupButton } from './groupButton';
import Utils from '../../../../utils/utils';
import styles from './groups.module.scss';
export var Groups = function (_a) {
    var groups = _a.groups, values = _a.values, onUpdate = _a.onUpdate;
    return (React.createElement("div", { className: styles['group-contained'] }, groups.map(function (gr) { return (React.createElement(GroupButton, { name: 'groups', type: "checkbox", key: "group_".concat(gr.id), label: React.createElement("img", { className: styles['groups-list-item'], alt: gr.id, src: "".concat(Utils.getAssetsDomain(), "/images/groups/group_").concat(gr.id, "/logo.jpg") }), onChange: onUpdate, value: gr.id, checked: values && values.includes(gr.id) })); })));
};
